import { thirdPartyServices } from '@chilipiper/config'
import { chiliTrack } from '../chili-track'
import { isCypress } from '../is-cypress'
import { Mixpanel } from '../chili-track/chili-mixpanel'
import mixpanelMock from './mixpanel-mock'

let mixpanel: Mixpanel

if (isCypress || process.env.NODE_ENV === 'test' || !thirdPartyServices.useMixpanel) {
  mixpanel = mixpanelMock
} else {
  mixpanel = chiliTrack.mixpanel
}

const mixpanelSdk = mixpanel

export { mixpanelSdk }

export default mixpanel
